import React, { Component } from 'react';
import { APP_URL_API } from '../../setup/configs'
import AnnualReport from './AnnualReport';
import Donations from './Donations';
import Members from './Members'
import axios from 'axios';
import RadioButtons from './RadioButtons'

const yearForNewUI = 2023;

export default class Year extends Component {
    constructor(props) {
        super(props);
        this.fileInput1Ref = React.createRef();
        this.fileInput2Ref = React.createRef();

        this.state = {
            annualReportFile: null,
            donationsFile: null,
            donationsAccepted: null,
            donationsLargeAmount: null,
            donationsInReport: null,
            currentAnnualReportInherited: null,
            accept: false,
            gdpr: false,
            currentAnnualReportContent: this.props.currentAnnualReport,
            showModal: false,
            showAlertModal: false,
            modalText: '',
            advancedInterface: false,
            locked: false,
            annualReportWaitingForApproval: false,
            approved: false
        }
    }

    componentDidMount() {
        this.setState({
            advancedInterface: this.props.year >= yearForNewUI,
            locked: this.props.currentAnnualReport.unlocked === 1 ? false : true,
            currentAnnualReportInherited: this.props.currentAnnualReportInherited,
            annualReportWaitingForApproval: this.props.annualReportWaitingForApproval
        })
    }

    onHandleApproveDocument = (documentId) => {
        // Call API 
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const data = {};
        data._method = "patch";

        if (this.state.donationsFile === null && this.props.currentDonationId && !this.state.advancedInterface) {
            this.props.deleteDocumentFromServer(this.props.currentDonationId);
        }

        if(!this.state.advancedInterface) {
            const url1 = APP_URL_API + 'files/' + this.props.annualReportWaitingForApproval.id + '/approveDocument';
            const url2 = APP_URL_API + 'files/' + this.props.donationWaitingForApproval.id + '/approveDocument';

            let requests = [];

            const request1 = axios.post(url1, data, { headers: config });
            requests.push(request1);

            if(this.props.donationWaitingForApproval.id) {
                const request2 = axios.post(url2, data, { headers: config });
                requests.push(request2);
            }

            Promise.all(requests)
                .then((results) => {
                    this.setState({
                        annualReportWaitingForApproval: false,
                        locked: true
                    });
                })
        } else {
            const url = APP_URL_API + 'files/' + documentId + '/approveDocument';
            this.serverRequest =
                axios
                    .post(url, data, { headers: config })
                    .then(function(response) {
                        this.setState({
                            annualReportWaitingForApproval: false,
                            locked: true
                        });
                    }.bind(this));
        }
    }

    onHandleRejectDocument = (documentId) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'files/' + documentId;

        let requests = [];

        if(!this.state.advancedInterface) {
            const url1 = APP_URL_API + 'files/' + this.props.annualReportWaitingForApproval.id;
            const url2 = APP_URL_API + 'files/' + this.props.donationWaitingForApproval.id;

            const request1 = axios.delete(url1, { headers: config });
            requests.push(request1);

            if(this.props.donationWaitingForApproval.id) {
                const request2 = axios.delete(url2, { headers: config });
                requests.push(request2);
            }
        } else {
            const request = axios.delete(url, { headers: config });
            requests.push(request);
        }

        Promise.all(requests)
                .then((results) => {
                    this.setState({
                        annualReportWaitingForApproval: false,
                        locked: true
                    });
                })
    }

    onHandleLockingDocument(lockStatus, documentType) {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const action = lockStatus === 'lock' ? 'lockFileUpload' : 'unlockFileUpload';
        const document_id = documentType == 'donations' ? this.props.currentDonationId : this.props.currentAnnualReportId;

        const data = {};
        data._method = "patch";

        if(!this.state.advancedInterface) {
            const url1 = APP_URL_API + 'files/' + this.props.currentAnnualReportId + '/' + action;
            const url2 = APP_URL_API + 'files/' + this.props.currentDonationId + '/' + action;

            let requests = [];

            const request1 = axios.post(url1, data, { headers: config });
            requests.push(request1);

            if(this.props.currentDonationId) {
                const request2 = axios.post(url2, data, { headers: config });
                requests.push(request2);
            }

            this.props.updateUnlockedStatus(this.props.year, lockStatus === 'lock' ? 0 : 1);

            Promise.all(requests)
                .then((results) => {
                    this.setState({
                        locked: !this.state.locked
                    });
                })
        } else {
            const url = APP_URL_API + 'files/' + document_id + '/' + action;

            this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                    this.setState({
                        locked: !this.state.locked
                    })
                }.bind(this))
        }
    }

    onAttachCommunityAnnualReport = (id) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'congregations/' + this.props.organizationId + '/link/annualReport/' + id;

        const data = {};
        data._method = "patch";

        this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                    this.setState({
                        currentAnnualReportInherited: true,
                    })
                }.bind(this))
    }

    onDetachCommunityAnnualReport = (id) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token };
        const url = APP_URL_API + 'congregations/' + this.props.organizationId + '/unlink/annualReport/' + id;

        const data = {};
        data._method = "patch";

        this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                    this.setState({
                        currentAnnualReportInherited: false,
                    })
                }.bind(this))
    }

    onToggleModal = () => {
        this.setState({
            showModal: this.state.showModal ? false : true
        });
    }

    onCloseModal = () => {
        if(this.fileInput1Ref.current) this.fileInput1Ref.current.value = "";
        if(this.fileInput2Ref.current) this.fileInput2Ref.current.value = "";

        this.setState({
            annualReportFile: null,
            donationsFile: null,
            showModal: false,
            accept: false
        })
    }

    onChange = (e) => {
        if(e.target.type==="file") {
            if(e.target.files[0].type === 'application/pdf') {
                this.setState({
                    [e.target.name]: e.target.files[0]
                })
            } else {
                this.setState({
                    modalText: 'Forkert filtype. Kun PDF-filer på max 20 MB tilladt.',
                    showAlertModal: true,
                    showModal: false
                });
                e.target.value = "";
            }
        } else if(e.target.type==="checkbox"){
            this.setState({
                [e.target.name]: e.target.checked
            })
        } else if(e.target.type==="radio"){
            this.setState({
                [e.target.name]: e.target.value
            })
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if((this.props.user.type==="admin" && !this.state.annualReportFile) ||
                (this.props.user.type==="user" && (!this.state.annualReportFile || !this.state.accept))) {
            this.setState({
                    modalText: 'Du skal vælge en fil og/eller godkende betingelserne',
                    showAlertModal: true,
                    showModal: false
            });
            return false;
        }
        
        let donations = 'none';
        let donationsGreaterThan20000 = 0;
            
        if(!this.state.advancedInterface) {
            if(this.state.donationsAccepted===null ||
                (this.state.donationsAccepted === "option1" && (this.state.donationsInReport===null || this.state.donationsLargeAmount===null))) {
                this.setState({
                        modalText: 'Du mangler at tage stilling til nogle valg under donationer',
                        showAlertModal: true,
                        showModalDonations: false
                });
                return false;
            }
            if(this.state.donationsAccepted === "option1" && this.state.donationsInReport===false && !this.state.donationsFile) {
                this.setState({
                        modalText: 'Du skal uploade bilag vedr. donationer',
                        showAlertModal: true,
                        showModalDonations: false
                });
                return false;
            }
            if(this.props.user.type==="user" && this.state.donationsAccepted === "option1" && (this.state.donationsInReport || this.state.donationsInReport===false) && !this.state.gdpr) {
                this.setState({
                        modalText: 'Du skal vælge en fil og/eller godkende betingelserne',
                        showAlertModal: true,
                        showModalDonations: false
                });
                return false;
            }

            if(this.state.donationsAccepted === "option1") {
                if(this.state.donationsInReport === "option1") donations = 'in_annual_report';
                if(this.state.donationsInReport === "option2") donations = 'in_own_document';
                if(this.state.donationsLargeAmount === "option1") donationsGreaterThan20000 = 1;
            }
        }

        this.setState({
            showModal: false
        });
        
        this.props.onHandlePrepareFileForUpload('annualReport', this.state.annualReportFile, '', this.props.year, donations, donationsGreaterThan20000);
        if(this.state.donationsFile) this.props.onHandlePrepareFileForUpload('donations', this.state.donationsFile, '', this.props.year);
    }

    closeAlertModal = () => {
        this.setState({
            showAlertModal: false, 
            showModal: true
        });
    }

    render() {
        return(
            <div className="flex flex-col gap-4 bg-lightgrey rounded my-4 py-8">  
                <div className="mx-8 border-bottom text-xl font-bold">
                    {this.props.year}
                </div>
                <div className="flex gap-4 items-start px-4">
                    
                    <AnnualReport 
                        annualReportFile={this.state.annualReportFile}
                        currentAnnualReport={this.props.currentAnnualReport} 
                        currentAnnualReportName={this.props.currentAnnualReportName} 
                        currentAnnualReportInherited={this.state.currentAnnualReportInherited}
                        currentDonationId={this.props.currentDonationId}
                        annualReportWaitingForApproval={this.state.annualReportWaitingForApproval}
                        donationWaitingForApproval={this.props.donationWaitingForApproval}
                        deleteDocumentFromServer={this.props.deleteDocumentFromServer}
                        onHandleFileDelete={this.props.onHandleFileDelete}
                        organizationType={this.props.organizationType}
                        user={this.props.user}
                        year={this.props.year}
                        organizationId={this.props.organizationId}
                        annualReportCommunity={this.props.annualReportCommunity}
                        donationCommunity={this.props.donationCommunity}
                        onAttachCommunityAnnualReport={this.onAttachCommunityAnnualReport}
                        onDetachCommunityAnnualReport={this.onDetachCommunityAnnualReport}
                        donations={{
                            accepted: this.state.donationsAccepted, 
                            inReport: this.state.donationsInReport, 
                            largeAmount: this.state.donationsLargeAmount, 
                            file: this.state.donationsFile
                        }}
                        onChange={this.onChange}
                        onSubmit={this.onSubmit}
                        onToggleModal={this.onToggleModal}
                        onCloseModal={this.onCloseModal}
                        showModal={this.state.showModal}
                        showAlertModal={this.state.showAlertModal}
                        modalText={this.state.modalText}
                        closeAlertModal={this.closeAlertModal}
                        inputRef1={this.fileInput1Ref}
                        inputRef2={this.fileInput2Ref}
                        accept={this.state.accept}
                        advancedInterface={this.state.advancedInterface}
                        onHandleLockingDocument={(lockStatus, documentType) => this.onHandleLockingDocument(lockStatus, documentType)}
                        locked={this.state.locked}
                        onHandleApproveDocument={this.onHandleApproveDocument}
                        onHandleRejectDocument={this.onHandleRejectDocument}
                    />
                   
                    <Donations 
                        currentDonation = {this.props.currentDonation}
                        currentDonationName = {this.props.currentDonationName}
                        currentDonationId={this.props.currentDonationId}
                        currentAnnualReport={!this.state.advancedInterface ? this.props.currentAnnualReport : null}
                        currentAnnualReportName={this.props.currentAnnualReportName}
                        currentAnnualReportInherited={this.state.currentAnnualReportInherited} 
                        deleteDocumentFromServer={this.props.deleteDocumentFromServer}
                        donationWaitingForApproval={this.props.donationWaitingForApproval}
                        donationCommunity={this.props.donationCommunity}
                        onHandleFileDelete={this.props.onHandleFileDelete}
                        organizationId={this.props.organizationId}
                        user={this.props.user}
                        year={this.props.year}
                        donationsFile={this.state.donationsFile}
                        formDataUpdated={this.props.formDataUpdated}
                        onSubmit={this.onSubmit}
                        donations={{
                            accepted: this.state.donationsAccepted, 
                            inReport: this.state.donationsInReport, 
                            largeAmount: this.state.donationsLargeAmount, 
                            file: this.state.donationsFile
                        }}
                        advancedInterface={this.state.advancedInterface}
                        onHandleLockingDocument={(lockStatus, documentType) => this.onHandleLockingDocument(lockStatus, documentType)}
                        locked={this.state.locked}
                    />
                    
                    <div className="flex flex-col flex-1 shrink px-4">
                    <Members
                        membershipsCount={this.props.membershipsCount}
                        membershipId={this.props.membershipId}
                        membershipLockedAt={this.props.membershipLockedAt}
                        year={this.props.year}
                        user={this.props.user}
                        organizationId={this.props.organizationId}
                        onHandleAddMembersCount={this.props.onHandleAddMembersCount} />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/Year.js